import React, { createContext, useContext } from 'react';

export const PostHogCtx = createContext({ capture: () => {} });
export const usePostHog = () => useContext(PostHogCtx);